import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import QrReader from 'react-qr-reader';
import DemoButton from './DemoButton';
import ErrorList from '../errorList';
import { Alert } from 'react-bootstrap';
import { IQrCodeReaderProps } from './types';
import { useAuthentication, Roles } from '../authentiction';
import { useTimeout } from 'beautiful-react-hooks';
import {
  INotificationModalProps,
  NotificationModal,
  useModal,
} from '../modals';
import getBadge from './getBadge';
import { IApiError } from '../../services';

const QrCodeReader: React.FC<IQrCodeReaderProps> = ({
  backUrl,
  mode = 'default',
  onSuccess,
}) => {
  const history = useHistory();
  const { showModal, hideModal } = useModal();
  const { hasRole } = useAuthentication();

  const [error, setError] = useState<Error | null>(null);
  const [ajaxErrors, setAjaxErrors] = useState<Array<string>>([]);
  const [isReady, setIsReady] = useState<boolean>(false);
  const [showQrReader, setShowQrReader] = useState<boolean>(true);

  const [isCleared, clearTimeoutRef] = useTimeout(() => {
    if (showQrReader) {
      history.replace(backUrl);
    }
  }, 10000);

  const showNotificationAndRedirect = (message: string): void => {
    const notificationProps: INotificationModalProps = {
      title: 'Invalid Badge',
      message,
      icon: ['far', 'exclamation-circle'],
      kind: 'danger',
      onRequestClose: () => {
        hideModal();
        history.replace(backUrl);
      },
    };

    showModal(NotificationModal, notificationProps);
  };

  const handleScan = (data: string | null) => {
    if (!data) return;

    const dataObject = JSON.parse(data);

    const { app, id } = dataObject;

    if (app === 'VisIT' && id) {
      const isRegistering: boolean = mode === 'register';

      if (!isCleared) {
        clearTimeoutRef();
      }

      setShowQrReader(false);

      getBadge(id)
        .then((response) => {
          if (isRegistering) {
            showNotificationAndRedirect(
              'The badge has already been registered.',
            );
            //setAjaxErrors(['The badge has already been registered.']);
          } else if (response.data.deactivated) {
            showNotificationAndRedirect('The badge has been deactivated.');
            //setAjaxErrors(['The badge has been deactivated.']);
          } else {
            return onSuccess(id);
          }
        })
        .catch((error: IApiError) => {
          if (error.errorNumber === 1002) {
            if (isRegistering) {
              return onSuccess(id);
            } else {
              showNotificationAndRedirect('The badge has not been registered.');
              //setAjaxErrors(['The badge has not been registered.']);
            }
          } else if (error.errorNumber === 1011) {
            showNotificationAndRedirect('The badge has been deactivated.');
            //setAjaxErrors(['The badge has been deactivated.']);
          } else {
            setAjaxErrors(error.messages);
          }
        });
    }
  };

  return (
    <>
      {error && <Alert variant="danger">{error.message}</Alert>}
      <ErrorList errors={ajaxErrors} />

      {ajaxErrors.length > 0 && (
        <Link to={backUrl} className="btn btn-secondary">
          Back
        </Link>
      )}

      {showQrReader && (
        <>
          <div
            className={
              isReady
                ? 'd-none'
                : 'd-flex justify-content-center align-items-center mt-5'
            }
          >
            <h3>Please wait...</h3>
          </div>
          <div className={isReady ? 'visible' : 'invisible'}>
            <QrReader
              delay={300}
              facingMode={hasRole(Roles.Guest) ? 'environment' : 'user'}
              onError={setError}
              onScan={handleScan}
              onLoad={() => {
                setIsReady(true);
              }}
              style={{
                maxWidth: '800px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            />
          </div>
          <DemoButton onClick={handleScan} />
        </>
      )}
    </>
  );
};

export default QrCodeReader;
